import React, { FC } from 'react'
import { declOfNum } from '../../../lib/utils'
import styles from './Rating.module.scss'
import StarIcon from '../../../public/static/icons/star.svg'
import cn from 'classnames'

const Rating: FC<{
  rating: number
  reviewsCount: number
  className?: string
  onClick?: () => void
}> = ({ rating, reviewsCount, className, onClick }) => {
  return (
    <div
      className={cn(
        styles.container,
        onClick && styles['container--pointer'],
        className,
      )}
      onClick={onClick}
    >
      <ul className={styles.list}>
        {Array.from({ length: 5 }, (v, i) => ++i).map((item) => (
          <li key={item}>
            <StarIcon
              className={cn(
                styles.star,
                item > Math.round(rating) && styles['star--disabled'],
              )}
            />
          </li>
        ))}
      </ul>
      <p className={styles.text}>
        {reviewsCount} {declOfNum(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}
      </p>
    </div>
  )
}

export default Rating
